interface EyeFocusSVGProps {
  color: string;
  style: React.CSSProperties;
}

const EyeFocusSVG = ({ color, style }: EyeFocusSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="59"
    height="50"
    viewBox="0 0 59 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_6226)">
      <path
        d="M46.8004 0.743652H56.0675V10.0108"
        stroke={color}
        strokeWidth="1.48699"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.9492 49.2701H2.68207V40.0029"
        stroke={color}
        strokeWidth="1.48699"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M56.0676 40.0029V49.2701H46.8005"
        stroke={color}
        strokeWidth="1.48699"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M2.68207 10.0113V0.744141H11.9492"
        stroke={color}
        strokeWidth="1.48699"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.5789 24.9991C20.5789 29.8584 24.5088 33.7883 29.3681 33.7883C34.2274 33.7883 38.1573 29.8584 38.1573 24.9991C38.1573 20.1399 34.2274 16.21 29.3681 16.21C24.5088 16.21 20.5789 20.1399 20.5789 24.9991Z"
        stroke={color}
        strokeWidth="1.48699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.6139 33.5625C45.1142 31.0665 45.9772 28.1323 45.9772 25.0123C45.9772 21.8923 45.0611 18.7723 43.4679 16.2231"
        stroke={color}
        strokeWidth="1.48699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0558 16.5684C13.5953 19.0378 12.7589 21.9189 12.7589 24.9991C12.7589 27.8668 13.4891 30.562 14.7637 32.912"
        stroke={color}
        strokeWidth="1.48699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3681 8.38987C29.3681 8.38987 45.1673 7.61982 57.9926 24.999C45.154 42.3782 29.3681 41.6081 29.3681 41.6081C29.3681 41.6081 13.5688 42.3782 0.74353 24.999C13.5821 7.61982 29.3681 8.38987 29.3681 8.38987Z"
        stroke={color}
        strokeWidth="1.48699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15.0558" cy="49.2689" r="0.743494" fill={color} />
      <path
        d="M19.1052 49.269H41.4366"
        stroke={color}
        strokeWidth="1.48699"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <circle cx="43.468" cy="49.2689" r="0.743494" fill={color} />
      <circle cx="15.0558" cy="0.743494" r="0.743494" fill={color} />
      <path
        d="M19.1052 0.743652H41.4366"
        stroke={color}
        strokeWidth="1.48699"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <circle cx="43.4679" cy="0.743494" r="0.743494" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_465_6226">
        <rect width="58.7361" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default EyeFocusSVG;
